export const LOGO_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_f536d5e5-ab21-4396-868c-357a4a751396/artifacts/16gfu3zn_copy_7422ECBC-9EF4-4177-A26C-640B71437EFA.jpeg";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1778671394516-8270eac13c42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxibGFuayUyMHQtc2hpcnQlMjBzdHVkaW8lMjBsaWdodGluZ3xlbnwwfHx8fDE3OTExMjI4MDh8MA&ixlib=rb-4.1.0&q=85",
  tee: "https://images.unsplash.com/photo-1778671394516-8270eac13c42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxibGFuayUyMHQtc2hpcnQlMjBzdHVkaW8lMjBsaWdodGluZ3xlbnwwfHx8fDE3OTExMjI4MDh8MA&ixlib=rb-4.1.0&q=85&h=1400",
  sweatshirt:
    "https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxibGFuayUyMHN3ZWF0c2hpcnQlMjBlbGVnYW50fGVufDB8fHx8MTc5MTEyMjgwOHww&ixlib=rb-4.1.0&q=85",
  hoodie:
    "https://images.unsplash.com/photo-1620799140188-3b2a02fd9a77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxibGFuayUyMGhvb2RpZSUyMGhhbmdlciUyMG1pbmltYWxpc3R8ZW58MHx8fHwxNzkxMTIyODA4fDA&ixlib=rb-4.1.0&q=85",
  craft:
    "https://images.unsplash.com/photo-1568288796918-03e7d93306bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxhcHBhcmVsJTIwZW1icm9pZGVyeSUyMGRldGFpbCUyMGNyYWZ0fGVufDB8fHx8MTc5MTEyMjgwOHww&ixlib=rb-4.1.0&q=85",
};

export const GARMENTS = {
  tshirt: { name: "The Majestic Tee", label: "T-Shirt", standard: 25, extended: 30, img: IMAGES.tee },
  sweatshirt: { name: "The Kreations Crew", label: "Sweatshirt", standard: 30, extended: 40, img: IMAGES.sweatshirt },
  hoodie: { name: "The Dream Hoodie", label: "Hoodie", standard: 35, extended: 45, img: IMAGES.hoodie },
};

export const SIZES = ["S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"];
export const STANDARD_SIZES = ["S", "M", "L", "XL"];
export const SHIPPING = 10;

export const unitPrice = (garment, size) =>
  GARMENTS[garment][STANDARD_SIZES.includes(size) ? "standard" : "extended"];

export const priceLine = (garment) =>
  `S–XL $${GARMENTS[garment].standard} · 2X+ $${GARMENTS[garment].extended}`;

export const COLORS = [
  { name: "White", hex: "#FFFFFF" },
  { name: "Ivory", hex: "#F5EFE6" },
  { name: "Blush", hex: "#E9BFC6" },
  { name: "Rose", hex: "#D87D92" },
  { name: "Sage", hex: "#A8B89A" },
  { name: "Forest", hex: "#2A5C43" },
  { name: "Gold", hex: "#D4AF37" },
  { name: "Navy", hex: "#22304A" },
  { name: "Charcoal", hex: "#3B3B3B" },
  { name: "Onyx", hex: "#141414" },
];

export const GALLERY = [
  {
    url: "https://images.unsplash.com/photo-1627225793904-a2f900a6e4cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxjdXN0b20lMjBwcmludGVkJTIwdC1zaGlydCUyMGVkaXRvcmlhbHxlbnwwfHx8fDE3OTExMjQ2MzB8MA&ixlib=rb-4.1.0&q=85",
    caption: "The Birthday Squad Tees",
    tag: "Custom Tees",
  },
  {
    url: "https://images.unsplash.com/photo-1589884047253-28d52f2891e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxlbWJyb2lkZXJlZCUyMHN3ZWF0c2hpcnQlMjBmbGF0bGF5fGVufDB8fHx8MTc5MTEyNDYzMHww&ixlib=rb-4.1.0&q=85",
    caption: "Midnight Rose Embroidery",
    tag: "Sweatshirt",
  },
  {
    url: "https://images.unsplash.com/photo-1611348440902-6ecc67f7a7f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHx0aWUlMjBkeWUlMjBob29kaWUlMjBicmlnaHR8ZW58MHx8fHwxNzkxMTI0NjM4fDA&ixlib=rb-4.1.0&q=85",
    caption: "Summer Sunset Tie-Dye",
    tag: "Hoodie",
  },
  {
    url: "https://images.unsplash.com/photo-1593980305574-77a4b3080e89?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxncmFwaGljJTIwdGVlJTIwaGFuZ2VyJTIwcGlua3xlbnwwfHx8fDE3OTExMjQ2MzB8MA&ixlib=rb-4.1.0&q=85",
    caption: "Abstract Blush Graphic Tee",
    tag: "Graphic Tee",
  },
  {
    url: "https://images.unsplash.com/photo-1725285336920-c3a04fd4e58e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxlbWJyb2lkZXJlZCUyMHN3ZWF0c2hpcnQlMjBmbGF0bGF5fGVufDB8fHx8MTc5MTEyNDYzMHww&ixlib=rb-4.1.0&q=85",
    caption: "Signature Golden Stitch",
    tag: "Detail Work",
  },
  {
    url: "https://images.unsplash.com/photo-1620799139507-2a76f79a2f4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxhZXN0aGV0aWMlMjBmbGF0bGF5JTIwYXBwYXJlbHxlbnwwfHx8fDE3OTExMjQ2Mzh8MA&ixlib=rb-4.1.0&q=85",
    caption: "Bridal Party Essentials",
    tag: "Group Set",
  },
];
